import { Paper, Tooltip, Typography } from '@mui/material';
import { MediaFileType } from "../../../models/media.models";
import { MediaModel } from '../../../models/conversations';
import { PdfIcon, ZipIcon, XlsIcon, MediaTxtIcon, MediaDefaultIcon, WordIcon, DownloadChatIcon, CancelIcon } from '../../../icon';
import * as selector from '../../../selectors/selectors'
import { useSelector } from 'react-redux';

interface Props {
    media: MediaModel;
    cross: boolean;
    fileDownload?: () => void;
    onClose?: () => void;
}

const File = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

    const getIcon = (type: string): any => {
        switch (type) {
            case MediaFileType.PDF:
                return <PdfIcon />
            case MediaFileType.ZIP:
                return <ZipIcon />
            case MediaFileType.DOC:
                return <WordIcon />
            case MediaFileType.DOCX:
                return <WordIcon />
            case MediaFileType.XLSX:
                return <XlsIcon />
            case MediaFileType.TXT:
                return <MediaTxtIcon />
            default:
                return <MediaDefaultIcon />
        }
    }

    const fileName = () => {
        var name = props.media.Name.split('.')[0]
        return name.slice(0, 15) + (name.length > 15 ? "..." : "");
    }
    const getFileExtension = () => {
        let parts = props.media.Name.split('.');
        return parts[parts.length - 1];
    }
    return (
        <Paper>
            <div className="d-flex p-1">
                <div className="my-auto ml-1">
                    {getIcon(getFileExtension())}
                </div>
                <div className="my-auto ml-1">
                    <Typography style={IsMobileDevice ? { wordBreak: "break-all", fontSize: "x-small" } : {}} >{fileName()}.{getFileExtension()}</Typography>
                </div>
                <div className="my-auto c-pointer d-flex">
                    {props.cross ? <Tooltip title='Close' placement='bottom-start'><CancelIcon className={"c-pointer my-auto ml-1"} onClick={props.onClose} /></Tooltip> : (IsMobileDevice && IsTeamsApp) ? "" : <Tooltip title='Download' placement='bottom-start'><DownloadChatIcon className={"c-pointer my-auto ml-1"} onClick={props.fileDownload} /></Tooltip>
                    }
                </div>
            </div>
        </Paper>
    )
}

export default File;